import QnaList from "../view/asQuestion/QnaList.svelte";
import QnaDtl from "../view/asQuestion/QnaDtl.svelte";
import QnaWrite from "../view/asQuestion/QnaWrite.svelte";

export const asQuestionRoutes = {
    "/as_question/qna_list": QnaList,
    "/as_question/qna_dtl": QnaDtl,
    "/as_question/qna_write": QnaWrite,
};